module.exports = __webpack_public_path__ + "img/KM.dc2b7340.svg";